module.exports = __webpack_public_path__ + "img/area_menu_more_select.9434bdaf.svg";